<template>
    <AuthPageInner title="Confirm Password">
        <ConfirmPasswordForm/>
    </AuthPageInner>
</template>

<script>

import AuthPageInner from "@/Components/Layout/AuthPageInner";
import ConfirmPasswordForm from "@/Components/Auth/ConfirmPasswordForm.vue";

export default {

    name: "ConfirmPasswordPage",

    components: {
        AuthPageInner,
        ConfirmPasswordForm
    },

    methods: {
        onSuccess() {
        }
    },

}
</script>
